import { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineArrowLeft } from "react-icons/ai";
import FeatureTopNav from "../../components/FeatureTopNav";
import TabComponent from "../../components/TabComponent";
import Event from "./EventCard";
import { fetchEvents, closeModal } from "../../actions/event.action";
import { Loading } from "../../utils/helpers/constants";
import RoundLoader from "../../components/loader/RoundLoader";
import CreateEventModal from "../../components/modals/CreateEventModal";
import EventSuccessModal from "../../components/modals/EventSuccessModal";
import { filterData } from "../../utils/helpers/dataHelper";
import EmptyListComponent from "../../components/EmptyListComponent";
import { categories } from "../../utils/mapper/enums/AppEnums";

export default function EventHome() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const cancelButtonRef = useRef(null);
  const [filterKey, setFilterKey] = useState("");

  const { profile } = useSelector(({ profileReducer }) => ({
    profile: profileReducer,
  }));

  const {
    event: { events, eventListLoading, modal },
  } = useSelector(({ eventReducer }) => ({
    event: eventReducer,
  }));

  useEffect(() => {
    dispatch(fetchEvents());
  }, []);

  const handleFilter = (value) => {
    setFilterKey(value);
  };

  const eventLoadState =
    eventListLoading === Loading.FETCHING ||
    profile.userProfileLoading === Loading.FETCHING;

  const eventTypes = [
    "CAREER",
    "ENTERTAINMENT",
    "GAMES",
    "MUSIC",
    "SPORTS",
    "TECHNOLOGY",
    "PARTY",
    "RELIGION",
  ];

  return (
    <div className="App-height p-5">
      <AiOutlineArrowLeft
        size={25}
        onClick={() => history.push("/dashboard/user/home")}
        className="mb-2 cursor-pointer"
      />
      <FeatureTopNav name={"Events"} handleCreate={() => setOpen(true)} />
      <TabComponent data={categories} handleFilter={(e) => setFilterKey(e)} />
      {eventLoadState ? (
        <RoundLoader />
      ) : (
        <>
          {filterData(events, filterKey, ["eventCategory"]).length === 0 ? (
            <EmptyListComponent text={"No event"} size={30} height={"h-36"} />
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-2 mt-2 h-32">
              {filterData(events, filterKey, ["eventCategory"]).map(
                (event, index) => {
                  return (
                    <Event
                      event={event}
                      key={index}
                      textEllipse={"two_line"}
                      imageHeight={"h-72"}
                    />
                  );
                }
              )}
            </div>
          )}
          <CreateEventModal
            open={open}
            setOpen={setOpen}
            cancelButtonRef={cancelButtonRef}
          />
          <EventSuccessModal
            open={modal}
            setOpen={setSuccessModal}
            closeModal={closeModal}
          />
        </>
      )}
    </div>
  );
}
